import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import { addSupplierApi } from '../../api/endpoints';
import { salesApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const sales = createAsyncThunk('sales', async (payload) => {
  return await salesApi(payload);
});

const salesSlice = createSlice({
  name: 'addSupplier', // Unique Name
  initialState,
  reducers: {
    salesReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(sales.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(sales.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(sales.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { salesReset } = salesSlice.actions;

export default salesSlice.reducer;
